export default __webpack_public_path__ + "static/media/Soulwound Gloves.ad4ff42e.jpg";